import React from 'react';
import BottomSheetModal from './BottomSheetModal';
import './HistoryModal.css';

/**
 * History Modal Component
 * Displays conversation history in a bottom sheet
 */
const HistoryModal = ({ 
  isOpen, 
  onClose, 
  conversations = [], 
  currentConversationId,
  onLoadConversation,
  onStartNewConversation
}) => {
  return (
    <BottomSheetModal
      isOpen={isOpen}
      onClose={onClose}
      title="Conversation History"
      maxHeight="70vh"
    >
      <div className="history-modal-content">
        {conversations.length === 0 ? (
          <div className="empty-history">
            <p>No conversations yet</p>
            <button 
              onClick={() => {
                onStartNewConversation();
                onClose();
              }}
              className="btn-primary"
            >
              Start New Conversation
            </button>
          </div>
        ) : (
          <div className="conversations-list">
            {conversations.map((conversation) => (
              <div
                key={conversation.id}
                className={`conversation-item ${currentConversationId === conversation.id ? 'active' : ''}`}
                onClick={() => {
                  onLoadConversation(conversation);
                  onClose();
                }}
              >
                <div className="conversation-title">
                  {conversation.title || 'Untitled Conversation'}
                </div>
                <div className="conversation-date">
                  {new Date(conversation.created_at).toLocaleDateString()}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </BottomSheetModal>
  );
};

export default HistoryModal; 